export default __webpack_public_path__ + "static/media/16.a735f741.png";